import { render, staticRenderFns } from "./TabType.vue?vue&type=template&id=0512624a&"
import script from "./TabType.vue?vue&type=script&lang=js&"
export * from "./TabType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports